module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box_s"
  }, [_c('el-form', {
    staticStyle: {
      "width": "95%"
    },
    attrs: {
      "label-width": "20px",
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p_b"
  }, [_vm._v("生产工艺 ")]), _vm._v(" "), _c('p', {
    staticClass: "b_p"
  }, [_vm._v("是否涉及危险工艺过程或国家规定的禁用工艺/设备是（多选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.isRiskInvolved),
      callback: function($$v) {
        _vm.$set(_vm.form, "isRiskInvolved", $$v)
      },
      expression: "form.isRiskInvolved"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.form.isRiskInvolved == 1) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList8),
      callback: function($$v) {
        _vm.checkList8 = $$v
      },
      expression: "checkList8"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("具有国家规定有淘汰期限的淘汰类落后生产工艺装备")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("属于《重点监管危险化工工艺目录》")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("易燃")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("易爆")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "5",
      "disabled": ""
    }
  }, [_vm._v("高温")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "6",
      "disabled": ""
    }
  }, [_vm._v("高压")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p_b"
  }, [_vm._v("安全生产控制 ")]), _vm._v(" "), _c('p', {
    staticClass: "b_p"
  }, [_vm._v("消防验收")]), _vm._v(" "), _c('p', [_vm._v("消防验收意见是否合格")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.isFireProtectionQualified),
      callback: function($$v) {
        _vm.$set(_vm.form, "isFireProtectionQualified", $$v)
      },
      expression: "form.isFireProtectionQualified"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("合格")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("不合格")])], 1), _vm._v(" "), _c('p', [_vm._v("最近一次消防检查是否合格")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.isLastFireProtectionQualified),
      callback: function($$v) {
        _vm.$set(_vm.form, "isLastFireProtectionQualified", $$v)
      },
      expression: "form.isLastFireProtectionQualified"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("合格")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("不合格")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("安全生产许可（单选）")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.safeProductionPermit),
      callback: function($$v) {
        _vm.$set(_vm.form, "safeProductionPermit", $$v)
      },
      expression: "form.safeProductionPermit"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("非危险化学品生产企业")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("危险化学品生产企业取得安全生产许可")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v("危险化学品生产企业未取得安全生产许可")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("危险化学品安全评价（单选）")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.safetyValuationOfDangerousChemicals),
      callback: function($$v) {
        _vm.$set(_vm.form, "safetyValuationOfDangerousChemicals", $$v)
      },
      expression: "form.safetyValuationOfDangerousChemicals"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("开展危险化学品安全评价并通过验收")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("开展危险化学品安全评价未通过验收")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v("未开展危险化学品安全评价")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("危险化学品重大危险源备案（单选）")]), _vm._v(" "), _c('el-radio-group', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.form.majorHazardOfDangerousChemicals),
      callback: function($$v) {
        _vm.$set(_vm.form, "majorHazardOfDangerousChemicals", $$v)
      },
      expression: "form.majorHazardOfDangerousChemicals"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("无重大危险源")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("所有危险化学品重大危险源均已备案")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 3,
      "disabled": ""
    }
  }, [_vm._v("有危险化学品重大危险源未备案")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p_b"
  }, [_vm._v("环境风险防控与应急措施 ")]), _vm._v(" "), _c('p', {
    staticClass: "b_p"
  }, [_vm._v("是否有截流措施(多选)")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.hasInterceptMeasure),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasInterceptMeasure", $$v)
      },
      expression: "form.hasInterceptMeasure"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.form.hasInterceptMeasure == 1) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList3),
      callback: function($$v) {
        _vm.checkList3 = $$v
      },
      expression: "checkList3"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("各个环境风险单元设防渗漏、防腐蚀、防淋溶、防流失措施，设防初期 雨水、泄漏物、受污染的消防水（溢）流入雨水和清净下水系统的导流 围挡收集措施（如防火堤、围堰等），且相关措施符合设计规范")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("装置围堰与罐区防火堤（围堰）外设排水切换阀，正常情况下通向雨水 系统的阀门关闭，通向事故存液池、应急事故水池、清净下水排放缓冲 池或污水处理系统的阀门打开")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("前述措施日常管理及维护良好，有专人负责阀门切换，保证初期雨水、 泄漏物和受污染的消防水排入污水系统")])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("是否有事故排水收集措施（多选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.hasAccidentDrainageCollectionMeasure),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasAccidentDrainageCollectionMeasure", $$v)
      },
      expression: "form.hasAccidentDrainageCollectionMeasure"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.form.hasAccidentDrainageCollectionMeasure == 1) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList4),
      callback: function($$v) {
        _vm.checkList4 = $$v
      },
      expression: "checkList4"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("按相关设计规范设置应急事故水池、事故存液池或清净下水排放缓冲池 等事故排水收集设施，并根据下游环境风险受体敏感程度和易发生极端 天气情况，设置事故排水收集设施的容量")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("事故存液池、应急事故水池、清净下水排放缓冲池等事故排水收集设施 位置合理，能自流式或确保事故状态下顺利收集泄漏物和消防水，日常 保持足够的事故排水缓冲容量")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("设抽水设施，并与污水管线连接，能将所收集物送至厂区内污水处理设施处理")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("清净下水系统防控措施（单选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.cleanWaterSystemProtectionMeasure),
      callback: function($$v) {
        _vm.$set(_vm.form, "cleanWaterSystemProtectionMeasure", $$v)
      },
      expression: "form.cleanWaterSystemProtectionMeasure"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("不涉及清净下水")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("涉及清净下水（多选）")])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "el-fade-in-linear"
    }
  }, [(_vm.form.cleanWaterSystemProtectionMeasure == 2) ? _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('el-checkbox-group', {
    model: {
      value: (_vm.checkList53),
      callback: function($$v) {
        _vm.checkList53 = $$v
      },
      expression: "checkList53"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("具有收集受污染的清净下水、初期雨水和消防水功能的清净下水排放缓 冲池（或雨水收集池），池内日常保持足够的事故排水缓冲容量；池内设 有提升设施，能将所集物送至厂区内污水处理设施处理")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("具有清净下水系统（或排入雨水系统）的总排口监视及关闭设施，有 专人负责在紧急情况下关闭清净下水总排口，防止受污染的雨水、清净 下水、消防水和泄漏物进入外环境")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("以上都没有")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("雨排水系统防控措施（多选）")]), _vm._v(" "), _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList6),
      callback: function($$v) {
        _vm.checkList6 = $$v
      },
      expression: "checkList6"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("具有收集初期雨水的收集池或雨水监控池；池出水管上设置切断阀，正 常情况下阀门关闭，防止受污染的水外排；池内设有提升设施，能将所集 物送至厂区内污水处理设施处理")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("具有雨水系统外排总排口（含泄洪渠）监视及关闭设施，有专人负责 在紧急情况下关闭雨水排口（含与清净下水共用一套排水系统情况）， 防止雨水、消防水和泄漏物进入外环境")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("如果有排洪沟，排洪沟不通过生产区和罐区，具有防止泄漏物和受污 染的消防水流入区域排洪沟的措施")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("以上都没有")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p_b"
  }, [_vm._v("生产废水处理系统防控措施")]), _vm._v(" "), _c('p', {
    staticClass: "b_p"
  }, [_vm._v("是否有废水产生或外排 有（多选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.hasWasteWater),
      callback: function($$v) {
        _vm.$set(_vm.form, "hasWasteWater", $$v)
      },
      expression: "form.hasWasteWater"
    }
  }, [_c('el-radio', {
    staticStyle: {
      "width": "60px"
    },
    attrs: {
      "label": 1,
      "disabled": ""
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('el-radio', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "label": 2,
      "disabled": ""
    }
  }, [_vm._v("否")])], 1), _vm._v(" "), (_vm.form.hasWasteWater == 1) ? _c('el-checkbox-group', {
    model: {
      value: (_vm.checkList),
      callback: function($$v) {
        _vm.checkList = $$v
      },
      expression: "checkList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("受污染的循环冷却水、雨水、消防水等排入生产污水系统或独立处理系统")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("生产废水排放前设监控池，能够将不合格废水送废水处理设施重新处理")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("如企业受污染的清净下水或雨水进入废水处理系统处理，则废水处理 系统应设置事故水缓冲设施")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("具有生产废水总排口监视及关闭设施，有专人负责启闭，确保泄漏物、 受污染的消防水、不合格废水不排出厂外")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "5",
      "disabled": ""
    }
  }, [_vm._v("以上都没有")])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("毒性气体泄漏紧急处置装置（单选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.toxicGasLeakEmerDisposalDevice),
      callback: function($$v) {
        _vm.$set(_vm.form, "toxicGasLeakEmerDisposalDevice", $$v)
      },
      expression: "form.toxicGasLeakEmerDisposalDevice"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("不涉及有毒有害气体")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("涉及有毒有害气体，不具备有毒有害气体泄漏紧急处置装置")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("涉及有毒有害气体，具有针对有毒有害气体（如硫化氢、氰化氢、氯化氢、 光气、氯气、氨气、苯等）的泄漏紧急处置措施")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("毒性气体泄漏监控预警措施（单选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.toxicGasLeakEmerMonitorMeasure),
      callback: function($$v) {
        _vm.$set(_vm.form, "toxicGasLeakEmerMonitorMeasure", $$v)
      },
      expression: "form.toxicGasLeakEmerMonitorMeasure"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("不涉及有毒有害气体")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("涉及有毒有害气体，不具备生产区域或厂界有毒有害气体泄漏监控预警措施的")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("涉及有毒有害气体，具有针对有毒有害气体（如硫化氢、氰化氢、氯化氢、 光气、氯气、氨气、苯等）设置生产区域或厂界泄漏监控预警措施")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "arr_b",
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("环评及批复的其他风险防控措施落实情况（单选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.otherRiskControlSituation),
      callback: function($$v) {
        _vm.$set(_vm.form, "otherRiskControlSituation", $$v)
      },
      expression: "form.otherRiskControlSituation"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("按环评及批复文件的要求落实的其他建设环境风险防控设施的。")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("未落实环评及批复文件中其他环境风险防控设施要求的。")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "arr_b",
    attrs: {
      "label": ""
    }
  }, [_c('p', {
    staticClass: "b_p"
  }, [_vm._v("雨排水、清净下水、生产废水排放去向（单选）")]), _vm._v(" "), _c('el-radio-group', {
    model: {
      value: (_vm.form.waterEmission),
      callback: function($$v) {
        _vm.$set(_vm.form, "waterEmission", $$v)
      },
      expression: "form.waterEmission"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("不产生废水或废水处理后100%回用")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("进入城市污水处理厂或工业废水集中处理厂（如工业园区的废水处理厂）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("进入其它单位")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("其他（包括回喷、回灌、回用等）")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "5",
      "disabled": ""
    }
  }, [_vm._v("直接进入海域或江河、湖、库等水环境")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "6",
      "disabled": ""
    }
  }, [_vm._v("进入城市下水道再入江河湖库或进入城市下水道再入沿海海域")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "7",
      "disabled": ""
    }
  }, [_vm._v("直接进入污灌农田或进入地渗或蒸发地")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33ffbede","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/digtization/process.vue
// module id = 1204
// module chunks = 2